import React from 'react';
import styled from 'styled-components';
import { number, object, string } from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { format } from '@olxbr/mojo-jojo/utils/string';

const Container = styled.div`
  ${({ marginBottom }) => {
    if (marginBottom) {
      return `margin-bottom: ${marginBottom}`;
    }

    return '';
  }}
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  background: #6E0AD6;
  color: #FFFFFF;
  text-align: center;
  background: ${() => (`url(${process.env.PUBLIC_URL}/images/banner-msite.png) center no-repeat`)};
  background-size: cover;

  @media (min-width: 1000px) {
    background: ${() => (`url(${process.env.PUBLIC_URL}/images/banner-desk.png) center no-repeat`)};
    background-size: cover;
  }
  `;

const BannerTitle = styled.div`
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
  padding-bottom: 12px;

  width: 80%;
  padding-top: 24px;
  @media (min-width: 1000px) {
    font-size: 36px;
    line-height: 44px;
  }
`;

const BannerSubtitle = styled.div`
  font-size: 14px;
  line-height: 20px;
  width: 80%;
  padding-bottom: 24px;

  @media (min-width: 1000px) {
    font-size: 20px;
    line-height: 28px;
  }
`;

const Banner = ({ content, discount, marginBottom }) => (
  <Container marginBottom={marginBottom}>
    <BannerTitle>
      <ReactMarkdown
        source={format(content.bannerTitle, { discount })}
      />
    </BannerTitle>
    {
      content.bannerSubtitle && (
      <BannerSubtitle>
        { content.bannerSubtitle }
      </BannerSubtitle>)
    }
  </Container>
);

export default Banner;

Banner.propTypes = {
  content: object.isRequired,
  discount: number.isRequired,
  marginBottom: string,
};

Banner.defaultProps = {
  marginBottom: null,
};
